document.addEventListener( 'DOMContentLoaded', function() {
  var splide = new Splide( '.splide' , {
        type   : 'loop',
        perPage: 5,
        breakpoints: {
            1200: {
                perPage: 3,
               
              },
            1024: {
              perPage: 2,
             
            },
            767: {
              perPage: 2,
          
            },
            640: {
              perPage: 1,
        
            },
          },
        perMove: 1,
        gap: '2em',
        pagination:false,

      } );
      splide.mount();
} );

// Vertical Slide

document.addEventListener('DOMContentLoaded', function () {
  if( jQuery('.splide__vertical').length < 1 )
  return;

      var splide = new Splide( '.splide__vertical', {
        direction: 'ttb',
        height   : '400px',
        wheel    : true,
        perPage: 3,
        pagination:false,

        classes: {
          arrows: 'splide__arrows class-arrows',
          arrow : 'splide__arrow class-arrow',
          prev  : 'splide__arrow--prev class-prev',
          next  : 'splide__arrow--next class-next',
    },
      } );
      
      splide.mount();
    });

    // Testimonials Slider
  
    document.addEventListener('DOMContentLoaded', function () {

      if( jQuery('#splide_testimonial').length < 1 )
        return;
      var splide = new Splide( '#splide_testimonial', {
        perPage: 3,
        perMove: 1,
        gap: "30px",
        pagination: false,
        breakpoints: {
            1200: {
                perPage: 3,
               
              },
            1024: {
              perPage: 2,
             
            },
            767: {
              perPage: 2,
          
            },
            640: {
              perPage: 1,
        
            },
          },
        perMove: 1,
        pagination:false,

      } );
      
      splide.mount();
    });


 